export default {
    promo: {
        navigation: [
            {
                title: 'About',
                to: '/about',
            },
            {
                title: 'Documentation',
                to: '/documentation',
                isLink: true,
            },
            {
                title: 'Contact Us',
                to: '/contact',
            },
            {
                title: 'Sign In',
                to: '/login',
            },
            {
                title: 'Sign-up',
                to: '/sign-up',
            },
        ],
    },
};
